import React from 'react';
import AddButton from '../buttons/add-button';
import DeleteButton from '../buttons/delete-button';
import ActionButton from '../buttons/action-button';

const NamedEntityList = ({entities, addButtonLabel, addAction, editAction, deleteAction, errorHandler}) => {

  return <ul className="list-group">
    {(entities || []).map(entity => <li key={entity.id} className="list-group-item">
      <div className="row align-items-center">
        <div className="col">
          {entity.name || ''}
        </div>
        {editAction &&
        <div className="col-auto">
          <ActionButton className="btn-primary btn-sm px-4"
                        action={() => editAction(entity.id)}
                        errorHandler={errorHandler}>
            Edit
          </ActionButton>
        </div>
        }
        {deleteAction &&
        <div className="col-auto">
          <DeleteButton action={() => deleteAction(entity.id)}
                        errorHandler={errorHandler}/>
        </div>
        }
      </div>
    </li>)}
    {addAction &&
    <li className="list-group-item">
      <div className="row justify-content-end">
        <div className="col-auto">
          <AddButton action={addAction}
                     errorHandler={errorHandler}>
            {addButtonLabel}
          </AddButton>
        </div>
      </div>
    </li>
    }
  </ul>;
};

export default NamedEntityList;